import React, { useState } from 'react';
import Step1 from './components/Step1';
import Step2 from './components/Step2';
import Step3 from './components/Step3';
import './App.css'; 
import { db, storage } from './firebase-config';
import { useHistory } from 'react-router-dom';
import logo from './assets/logo.jpg'; 
import { useFileContext } from '../src/context/FileContext';


const App = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [personalDetails, setPersonalDetails] = useState({});
  const { fileData } = useFileContext();
  const [fileInputs, setFileInputs] = useState({});
  const [computerLiteracy, setComputerLiteracy] = useState({});
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const handleNextStep = (data) => {
    setPersonalDetails(data);
    setCurrentStep(currentStep + 1);
  };

  const handlePrevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleFileStep = (data) => {
    setFileInputs(data);
    setComputerLiteracy(data.computerLiteracy);
    setCurrentStep(currentStep + 1);
  };

  const handleSubmit = async  () => {
    setLoading(true);
  
    try {
  
      const personalDetailsRef = await db.collection('users-prod').add({
        personalDetails: personalDetails.formData,
        computerLiteracy: computerLiteracy
      });
  
      const storageRef = storage.ref(personalDetailsRef.id);

      const fileRefs = await Promise.all(
        Object.entries(fileInputs.fileUploads).map(async ([fieldName, file]) => {
          if (file) {
            
            const fileRef = storageRef.child(`${fieldName}.${file.name.split('.').pop()}`);
            
            await fileRef.put(file);
  
            const downloadURL = await fileRef.getDownloadURL();
  
            personalDetails.formData[fieldName] = downloadURL;
  
            return { fieldName, downloadURL };
          }
  
          return null;
        })
      );

    await db.collection('users-prod').doc(personalDetailsRef.id).update({
      fileReferences: fileRefs.filter(Boolean), // Filter out null values
    })
    //Email function here

    const userConfirmationHtml = `

            <h1>Thank you for your submission.</h1>
          
           <p> We appreciate your interest. If you have any questions, feel free to contact us.</p>

           <p>Please do not reply to this email account as it is not monitored.</p>
    
  `;
    // const userEmailResponse = await fetch('https://king-james-node-backend.vercel.app/send-email', {
    //   method: 'POST',
    //   headers: {
    //     'Content-Type': 'application/json',
    //   },
    //   body: JSON.stringify({
    //     to: personalDetails.formData.email,
    //     subject: 'Submission Confirmation',
    //    text:userConfirmationHtml
    //   }),
    // });

    // if (userEmailResponse.ok) {
    //   console.log('Email user sent successfully');
    // } else {
    //   console.error('Error sending user email');
    // }

    const adminNotificationHtml = `
      <p>New submission received:</p>
      <pre>${JSON.stringify(personalDetails, null, 2)}</pre>
    `;

    const adminEmailResponse = await fetch('https://king-james-node-backend.vercel.app/send-email', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        to: 'admin@elc.org.za',
        subject: 'New Submission',
        text: adminNotificationHtml,
        attachments: fileInputs.fileUploads
      }),
    });

    if (adminEmailResponse.ok) {
      console.log('Email admin sent successfully');
    } else {
      console.error('Error sending admin email');
    }

    history.push('/thank-you');
 
    } catch (error) {
      console.error('Error storing data,file and sending email :', error.message);
    }finally {
      setLoading(false);
    }
  };


  return (
    <div className="container">
      <div className="logo">
        <img src={logo} alt="Logo" />
      </div>
      <div className="header">
        <h1>Application for Admission</h1>
      </div>

      <div className="step-indicator">
        <div className={`step ${currentStep === 1 ? 'active' : ''}`}>1</div>
        <div className={`step ${currentStep === 2 ? 'active' : ''}`}>2</div>
        <div className={`step ${currentStep === 3 ? 'active' : ''}`}>3</div>
      </div>

      {currentStep === 1 && <Step1 onNext={handleNextStep} />}
      {currentStep === 2 && <Step2 onPrev={handlePrevStep} onNext={handleFileStep} personalDetails={personalDetails} />}
      {currentStep === 3 && (
        <Step3 onPrev={handlePrevStep} onSubmit={handleSubmit} disabled={loading} personalDetails={personalDetails} fileData={fileData} computerLiteracy={computerLiteracy} />
      )}

{loading && (
        <div className="loading-overlay">
          <div className="loading-indicator"></div>
        </div>
      )}
    </div>
  );
};

export default App;
